import React, { useContext } from "react";
import { Button, FormGroup, FormHelperText, Stack, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import SheetsSelect from "../generate/elements/pageContents/overview/SheetsSelect";
import ItemSheetsSelect from "../generate/elements/pageContents/overview/ItemSheetsSelect";
import { QuestionsContext } from "../../../provider/MyContexts";

type Props = {
  selectedMenu: string;
  setShowPage: (showPage: string) => void;
};
export default function Settings(props: Props) {
  const { selectedMenu, setShowPage } = props;
  const { loadSheetNames, selectedSheet } = useContext(QuestionsContext);

  function switchContents() {
    switch (selectedMenu) {
      case "generate":
        return (
          <FormGroup>
            <SheetsSelect />
            <ItemSheetsSelect />
            <FormHelperText>
              <Typography variant="body_S">
                新規作成するとき:
                記載のない調査票シートと、記入済みの項目一覧シートを選択してください。
              </Typography>
            </FormHelperText>
            <FormHelperText>
              <Typography variant="body_S">
                一部修正するとき: 修正したい調査票シートだけを選択してください。
              </Typography>
            </FormHelperText>
          </FormGroup>
        );

      case "review":
        return (
          <FormGroup>
            <SheetsSelect />
            <FormHelperText>チェックしたい調査票シートを選択してください。</FormHelperText>
          </FormGroup>
        );

      default:
        return <></>;
    }
  }

  if (!selectedMenu) {
    return <></>;
  }

  return (
    <Stack
      direction={"row"}
      width={"100%"}
      paddingX={4}
      paddingTop={1}
      justifyContent={"center"}
      minHeight={"200px"}
    >
      {/* <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} border={1} width={"100%"} padding={1} > */}
      <Stack width={"100%"} direction={"column"}>
        {switchContents()}
        <Stack direction={"row"} justifyContent={"flex-end"}>
          <Button
            sx={{
              width: "100px",
              height: "30px",
              borderRadius: "4px",
              maxWidth: "100px",
              padding: 0,
              color: "primary.main",
              marginBottom: 1,
            }}
            onClick={() => {
              loadSheetNames();
            }}
          >
            <RefreshIcon fontSize="small" />
            <Typography variant="label_S">{"再読み込み"}</Typography>
          </Button>
        </Stack>
      </Stack>
      <Stack width={"140px"} justifyContent={"center"} alignItems={"center"}>
        <Button
          variant="contained"
          disabled={!selectedSheet}
          onClick={() => {
            setShowPage(selectedMenu);
          }}
        >
          <Typography variant="button">進む</Typography>
        </Button>
      </Stack>
    </Stack>
    // </Stack>
  );
}
